import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { withResolvePaths } from "../../withResolvePaths";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";

import { Link } from "./Link";

interface LinkContainerProps extends FormActionHandlerExecutionInjectableProps {
    bindingPath?: AbsoluteModelPath;
    onClick?: FormActionHandler;
    disabled2?: EvaluableProp<boolean>;
    hrefExpression?: EvaluableProp<string>;
    href?: string;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: LinkContainerProps) => {
    const { disabled2, processEvaluableProp, hrefExpression } = ownProps;
    const result: { disabled?: boolean; href?: string } = {};
    if (disabled2 != undefined) {
        result.disabled = processEvaluableProp(state, disabled2);
    }
    if (hrefExpression != undefined) {
        result.href = processEvaluableProp(state, hrefExpression);
    }
    return result;
};

const mapDispatchToProps = (_: CandyDispatch, ownProps: LinkContainerProps) => ({
    onClick: async () => {
        if (ownProps.onClick != undefined) {
            await ownProps.executeFormActionHandler(ownProps.onClick);
        }
    },
});

export const LinkContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withViewModelSelect(
            withFocusManagement(
                withEvaluators(connect(mapStateToProps, mapDispatchToProps)(withTestPageObjectRegistration(Link)))
            )
        )
    )
);
